import { render, staticRenderFns } from "./dataDown.vue?vue&type=template&id=6115fc48&scoped=true"
import script from "./dataDown.vue?vue&type=script&lang=js"
export * from "./dataDown.vue?vue&type=script&lang=js"
import style0 from "./dataDown.vue?vue&type=style&index=0&id=6115fc48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6115fc48",
  null
  
)

export default component.exports